.calendar {
  display: flex;
  flex-direction: column;
  gap: 6px;
  user-select: none;
}

.header {
  align-items: center;
  display: flex;
  justify-content: space-between;
}

.month-label {
  color: var(--color-foreground);
  font-size: 13px;
  font-weight: 600;
}

.nav {
  align-items: center;
  background: transparent;
  border: none;
  border-radius: 6px;
  color: var(--color-muted);
  cursor: pointer;
  display: inline-flex;
  height: 28px;
  justify-content: center;
  width: 28px;

  &:hover {
    background: var(--color-secondary);
    color: var(--color-foreground);
  }
}

.weekdays,
.grid {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
}

.weekday {
  color: var(--color-muted);
  font-size: 11px;
  font-weight: 500;
  padding: 2px 0;
  text-align: center;
}

.day {
  align-items: center;
  background: transparent;
  border: none;
  color: var(--color-foreground);
  cursor: pointer;
  display: inline-flex;
  font-family: inherit;
  font-size: 13px;
  height: 34px;
  justify-content: center;
  // Square cells abut so the range fill reads as one continuous band; the
  // start/end pills round their outer edge.
  width: 100%;

  // Only un-selected days get the neutral hover — selected pills keep their
  // accent on hover instead of flashing grey.
  &:not(.day-in-range):hover {
    background: var(--color-secondary);
  }
}

.day-muted {
  color: var(--color-muted);
  opacity: 0.45;
}

.day-in-range {
  background: var(--color-accent);
  color: var(--color-accent-foreground);
}

.day-start,
.day-end,
.day-single {
  background: var(--color-primary);
  color: var(--color-primary-foreground);
  font-weight: 600;
}

.day-start {
  border-radius: 8px 0 0 8px;
}

.day-end {
  border-radius: 0 8px 8px 0;
}

.day-single {
  border-radius: 8px;
}

.day-today:not(.day-start):not(.day-end):not(.day-single) {
  box-shadow: inset 0 0 0 1px var(--color-primary);
  border-radius: 8px;
}
